enum FeeDisplayLayout {
	NoFee,
	DetailFee,
	SummaryFee,
	Bonus,
	FeeWithVat,
	VatFeePlus,
	Bonification,
	BSM,
	FeeWithTwoVats,
	AmountPlusVat
}

export default FeeDisplayLayout;
